import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';

import { ta } from '../../i18n/adminT';
// Elenco volutamente breve: identificativi IANA validi, quelli più
// plausibili per le installazioni di questo prodotto. Il campo accetta
// comunque qualunque fuso IANA valido, non solo questi.
const TIMEZONE_OPTIONS = [
  { value: 'Europe/Rome', label: 'Europe/Rome (Italia)' },
  { value: 'Europe/London', label: 'Europe/London' },
  { value: 'Europe/Paris', label: 'Europe/Paris' },
  { value: 'Europe/Berlin', label: 'Europe/Berlin' },
  { value: 'Europe/Madrid', label: 'Europe/Madrid' },
  { value: 'UTC', label: 'UTC' },
];

export default function AutoCloseSettings() {
  const [enabled, setEnabled] = useState(false);
  const [time, setTime] = useState('20:00');
  const [timezone, setTimezone] = useState('Europe/Rome');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.getAutoCloseConfig()
      .then((res) => {
        setEnabled(Boolean(res?.data?.enabled));
        setTime(res?.data?.time || '20:00');
        setTimezone(res?.data?.timezone || 'Europe/Rome');
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    setError('');
    setSaved(false);
    setSaving(true);
    try {
      await api.saveAutoCloseConfig({ enabled, time, timezone });
      setSaved(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return null;

  return (
    <div>
      <h1 className="admin-page-title">{ta('Chiusura automatica ingressi')}</h1>
      <p className="admin-page-subtitle">
        {ta('Chiude da sola le registrazioni ancora aperte oltre un certo orario, così non restano aperte fino al giorno dopo se un visitatore dimentica di timbrare l\'uscita.')}
      </p>

      <div className="admin-card" style={{ maxWidth: 480 }}>
        {error && <div className="form-error">{error}</div>}
        {saved && (
          <div style={{ background: 'rgba(62,142,126,0.12)', color: 'var(--teal-green-dark)', borderRadius: 'var(--radius-control)', padding: '10px 14px', fontSize: '0.85rem', marginBottom: 16 }}>
            {ta('Impostazioni salvate.')}
          </div>
        )}

        <label className="checkbox-row">
          <input
            type="checkbox"
            checked={enabled}
            onChange={(e) => { setEnabled(e.target.checked); setSaved(false); }}
          />
          <span>{ta('Attiva la chiusura automatica')}</span>
        </label>

        <div className="field" style={{ opacity: enabled ? 1 : 0.45, marginTop: 16 }}>
          <label htmlFor="auto-close-time">{ta('Orario di chiusura')}</label>
          <input
            id="auto-close-time"
            type="time"
            value={time}
            disabled={!enabled}
            onChange={(e) => { setTime(e.target.value); setSaved(false); }}
            style={{ width: 140 }}
          />
        </div>

        <div className="field" style={{ opacity: enabled ? 1 : 0.45 }}>
          <label htmlFor="auto-close-timezone">{ta('Fuso orario')}</label>
          <select
            id="auto-close-timezone"
            value={timezone}
            disabled={!enabled}
            onChange={(e) => { setTimezone(e.target.value); setSaved(false); }}
            style={{ width: 260 }}
          >
            {TIMEZONE_OPTIONS.map((tz) => (
              <option key={tz.value} value={tz.value}>{ta(tz.label)}</option>
            ))}
          </select>
        </div>

        <p style={{ fontSize: '0.78rem', color: 'var(--muted-text)', marginTop: 16, marginBottom: 16 }}>
          {ta('L\'orario e il fuso indicati qui sono indipendenti da come è configurato il server: si può cambiare il fuso senza dover intervenire sulla configurazione tecnica dell\'installazione. A quell\'orario, tutte le registrazioni ancora senza uscita registrata (di oggi o di giorni precedenti) vengono chiuse automaticamente, con l\'orario di uscita impostato sull\'orario di chiusura stesso. Chi si registra dopo quell\'orario resta comunque aperto fino alla chiusura del giorno successivo, se non timbra l\'uscita prima.')}
        </p>

        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSave}
          disabled={saving}
          style={{ width: 'auto', padding: '10px 20px' }}
        >
          {saving ? ta('Salvataggio…') : ta('Salva')}
        </button>
      </div>
    </div>
  );
}
